import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SearchFormSettingsComponent } from './app_manager/modal/client-detail/setting-behaviour/search-form-settings/search-form-settings.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { A2Edatetimepicker } from 'ng2-eonasdan-datetimepicker'
import { NgCircleProgressModule } from 'ng-circle-progress'
import { MatrixServices } from './services/image/matrix.services'
import { StateServices } from './services/state.services'
import { NvD3Module } from 'ng2-nvd3'
import { RenderFormSettingsComponent } from './app_manager/modal/client-detail/setting-behaviour/render-form-settings/render-form-settings.component'
import { ModalAlignerCreateComponent } from './app_manager/modal/client-detail/aligner/aligner-create/aligner-create.component'
import { ScrollbarModule } from 'ngx-scrollbar'
import { ModalAdjustmentAlignerComponent } from './app_manager/modal/client-detail/aligner/modal-adjustment-aligner/modal-adjustment-aligner.component'
import { OnsenModule } from 'ngx-onsenui'
import { ModalShowBigImagesComponent } from './app_manager/modal/client-detail/top/showBigImages/modal-show-big-images/modal-show-big-images.component'
import { CommonsModule } from './commons/commons.module'
import { ButtonShowBigImagesComponent } from '@modal/client-detail/top/showBigImages/button-show-big-images/button-show-big-images.component'
import { SharedModule } from '@app/shared/shared.module'

const DECLARES = [
    SearchFormSettingsComponent,
    RenderFormSettingsComponent,
    ModalAlignerCreateComponent,
    ModalAdjustmentAlignerComponent,
    ModalShowBigImagesComponent,
    ButtonShowBigImagesComponent,
]

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ScrollbarModule,
        OnsenModule,
        ReactiveFormsModule,
        A2Edatetimepicker,
        NvD3Module,
        CommonsModule,
        NgCircleProgressModule.forRoot({
            // set defaults here
            percent: 99,
            radius: 100,
            outerStrokeWidth: 16,
            innerStrokeWidth: 8,
            outerStrokeColor: '#0080ff',
            innerStrokeColor: '#53a9ff',
            animation: true,
            animationDuration: 300,
        }),
        SharedModule,
    ],
    declarations: [
        ...DECLARES,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ],
    providers: [
        MatrixServices,
        StateServices,
    ],
    exports: [
        ...DECLARES,
    ],
})
export class ShardModule {
}



// WEBPACK FOOTER //
// ./src/app/shard.module.ts